"use strict";

exports.__esModule = true;
exports.getTranslatedTicketPriorities = getTranslatedTicketPriorities;
var _constants = require("./constants");
function getTranslatedTicketPriorities(translate) {
  if (!translate) return _constants.TICKET_PRIORITIES;
  return _constants.TICKET_PRIORITIES.map(function (priority) {
    return Object.assign({}, priority, {
      value: translate("DataTable.TicketPriority." + priority.id, priority.id)
    });
  });
}